/**
 * Alert
 * ======================================
 * - close alert
 */

const ELEMENTS = '.js-alert'

class Alert {
  constructor() {
    this.elements = document.querySelectorAll(ELEMENTS)

    if (!this.elements) {
      return false
    }

    this.elements.forEach((el) => {
      el.addEventListener('click', this.close, false)
      el.addEventListener('touchstart', this.close, false)
    })
  }

  close(e) {
    const el = e.currentTarget
    el.closest('.header__alert').classList.add('is-hidden')
    e.preventDefault()
  }
}

new Alert()
